/* Shared "share this product" widget — see snippets/gw-share.liquid
   for the markup this wires up. One copy of this behaviour for every
   product-page layout, same pattern as assets/gw-wishlist.js. */
(function () {
  'use strict';

  function getVariantId(root) {
    var formId = root.getAttribute('data-gw-share-form-id');
    if (formId) {
      var form = document.getElementById(formId);
      var input = form ? form.querySelector('[name="id"]') : null;
      if (input && input.value) return input.value;
    }
    // No Dawn-style form on this layout (e.g. i-heart-parcel.liquid) —
    // fall back to whatever its own JS mirrors onto its add-to-basket
    // button (data-current-variant-id, kept live; data-default-variant-id
    // as the pre-interaction starting point), then to this widget's own
    // initial render.
    var addBtn = document.querySelector('[data-add-to-basket]');
    if (addBtn && (addBtn.dataset.currentVariantId || addBtn.dataset.defaultVariantId)) {
      return addBtn.dataset.currentVariantId || addBtn.dataset.defaultVariantId;
    }
    return root.getAttribute('data-gw-share-variant-id') || null;
  }

  function buildUrl(root, medium) {
    var path = root.getAttribute('data-gw-share-product-url') || '/';
    var url;
    try {
      url = new URL(path, window.location.origin);
    } catch (e) {
      url = new URL(window.location.origin + path);
    }
    var variantId = getVariantId(root);
    if (variantId) url.searchParams.set('variant', variantId);
    url.searchParams.set('utm_source', 'share');
    url.searchParams.set('utm_medium', medium);
    url.searchParams.set('utm_campaign', 'product_share');
    return url.toString();
  }

  function closeAllPopups(except) {
    document.querySelectorAll('[data-gw-share-popup]').forEach(function (p) {
      if (p === except) return;
      p.hidden = true;
      var trigger = p.__gwShareTrigger;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  // Positions the (now body-level, fixed) popup against its trigger's
  // current on-screen position, clamped into the viewport on every
  // side — flipping above the trigger when there isn't enough room
  // below. Fixed positioning is viewport-relative, so no scroll
  // offset is needed, and this is recalculated fresh on every open
  // (the trigger may have moved since the last time, e.g. the page
  // was scrolled or resized).
  function positionPopup(trigger, popup) {
    var margin = 8;
    var tRect = trigger.getBoundingClientRect();
    var pRect = popup.getBoundingClientRect();

    var left = tRect.right - pRect.width; // right-align with the trigger by default
    if (left < margin) left = margin;
    if (left + pRect.width > window.innerWidth - margin) {
      left = window.innerWidth - margin - pRect.width;
    }

    var top = tRect.bottom + margin;
    if (top + pRect.height > window.innerHeight - margin) {
      // Not enough room below — open upwards instead.
      top = tRect.top - margin - pRect.height;
    }
    if (top < margin) top = margin; // last resort: just keep it on screen

    popup.style.position = 'fixed';
    popup.style.top = top + 'px';
    popup.style.left = left + 'px';
    popup.style.right = 'auto';
    popup.style.bottom = 'auto';
  }

  function openPopup(trigger, popup) {
    closeAllPopups(popup);
    // Reparented to <body> (once) so it can never be trapped inside an
    // ancestor's stacking context — found live: .product__info-wrapper
    // has a CSS transform (creates its own stacking context) wrapping
    // the whole product-info column, so the popup's z-index only ever
    // competed with siblings INSIDE that column; a later, unrelated
    // section further down the page (shipping/returns/FAQ) painted on
    // top of that entire column regardless, since it's a later root-
    // level sibling with no competing stacking context of its own.
    // Moving the popup out to <body> (fixed position, computed in JS
    // below) escapes that entirely.
    if (popup.parentElement !== document.body) {
      document.body.appendChild(popup);
    }
    popup.__gwShareTrigger = trigger;
    popup.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    positionPopup(trigger, popup);
    var firstItem = popup.querySelector('.gw-share-popup__item');
    // preventScroll — without it, focusing this item can trigger the
    // browser's own scroll-into-view behaviour, which then immediately
    // fires the scroll listener below and closes the popup it was
    // just opened on (found live: the very first open after a fresh
    // page load reliably self-closed this way; a later open, once the
    // page had already settled, did not).
    if (firstItem) firstItem.focus({ preventScroll: true });
  }

  function closePopup(trigger, popup) {
    popup.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  }

  function showCopied(btn) {
    var label = btn.querySelector('[data-gw-share-copy-label]');
    if (!label) return;
    var original = label.textContent;
    label.textContent = 'Copied!';
    btn.setAttribute('data-copied', 'true');
    setTimeout(function () {
      label.textContent = original;
      btn.removeAttribute('data-copied');
    }, 2000);
  }

  function fallbackCopy(url, btn) {
    try {
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      showCopied(btn);
    } catch (e) {
      /* clipboard genuinely unavailable — nothing else to do */
    }
  }

  function copyLink(url, btn) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        showCopied(btn);
      }).catch(function () { fallbackCopy(url, btn); });
    } else {
      fallbackCopy(url, btn);
    }
  }

  function handleAction(root, action, btn, trigger, popup) {
    var title = root.getAttribute('data-gw-share-title') || document.title;
    var url = buildUrl(root, action);
    if (action === 'copy') {
      copyLink(url, btn);
      setTimeout(function () { closePopup(trigger, popup); }, 2000);
      return;
    }
    if (action === 'facebook') {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), 'gw-share-fb', 'width=600,height=400,noopener');
    } else if (action === 'whatsapp') {
      window.open('https://wa.me/?text=' + encodeURIComponent(title + ' ' + url), '_blank', 'noopener');
    } else if (action === 'email') {
      window.location.href = 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url);
    }
    closePopup(trigger, popup);
  }

  function initShare(root) {
    var trigger = root.querySelector('[data-gw-share-trigger]');
    var popup = root.querySelector('[data-gw-share-popup]');
    if (!trigger || !popup || trigger.dataset.gwShareWired) return;
    trigger.dataset.gwShareWired = '1';

    trigger.addEventListener('click', function () {
      var isCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
      if (isCoarsePointer && navigator.share) {
        var title = root.getAttribute('data-gw-share-title') || document.title;
        navigator.share({
          title: title,
          text: 'Look what I found at Goblin Wood',
          url: buildUrl(root, 'native')
        }).catch(function () { /* visitor cancelled — do nothing */ });
        return;
      }
      if (popup.hidden) {
        openPopup(trigger, popup);
      } else {
        closePopup(trigger, popup);
      }
    });

    popup.querySelectorAll('[data-gw-share-action]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        handleAction(root, btn.getAttribute('data-gw-share-action'), btn, trigger, popup);
      });
    });

    document.addEventListener('click', function (e) {
      if (popup.hidden) return;
      // popup may now live at the end of <body> (see openPopup), not
      // inside root — a click on anything in the popup itself must
      // still count as "inside", or it would close before this click
      // can reach its own action buttons.
      if (root.contains(e.target) || popup.contains(e.target)) return;
      closePopup(trigger, popup);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) {
        closePopup(trigger, popup);
        trigger.focus();
      }
    });

    // Fixed positioning is viewport-relative, so a scroll would leave
    // it visually "behind" relative to the trigger unless repositioned.
    // Re-running positionPopup (not closing) also sidesteps a real bug
    // this closing approach had: the page can genuinely scroll by a
    // pixel or two right after opening — e.g. the browser's own
    // scroll-anchoring compensating for other page content still
    // settling in right after navigation, nothing to do with this
    // click — and closing on ANY scroll event made that look
    // (incorrectly) like the popup had failed to open at all.
    window.addEventListener('scroll', function () {
      if (!popup.hidden) positionPopup(trigger, popup);
    }, { passive: true });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-gw-share]').forEach(initShare);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  window.gwShare = { init: initAll };
})();
